<template>
  <h4 class="pt-4">سوالات متداول</h4>
  <br/>
  <p class="bold-p px-2">
    1.چطور می شود کشف حجاب کسانی که پیاده هستند را در این سامانه ثبت کرد؟
  </p>
  <p class="bold-p px-2">
    این سامانه فقط مربوط به ثبت کشف حجاب داخل ماشین می باشد
  </p>
  <p class="bold-p px-2">
    2.کشف حجاب افراد داخل مغازه ها را در این سامانه چطور می توان ثبت کرد؟
  </p>
  <p class="bold-p px-2">
    در این سامانه فقط امکان ثبت کشف حجاب داخل ماشین می باشد و موارد دیگردر این سامانه انجام نمیشود.
  </p>
  <p class="bold-p px-2">
    3.اگرکشف حجاب روی موتورانجام بشه باید چکار کرد؟
  </p>
  <p class="bold-p px-2">
    در حال حاضر امکان ثبت تخلف موتور سیکلت در این سامانه وجود ندارد.
  </p>
  <p class="bold-p px-2">
    4.داخل پارک ها وجاهای تفریحی چطور میشود ثبت پلاک کرد؟
  </p>
  <p class="bold-p px-2">
    اگر فرد کشف حجاب کننده کنار ماشین بود و شما مطمئین شدید که وی مالک ماشین است، ثبت پلاک کنید و در قسمت
    توضیحات هم بنویسید، در غیر اینصورت و عدم اطمینان ثبت نکنید.
  </p>
  <p class="bold-p px-2">
    5.آیا در این سامانه تخلفات دیگر نظیر آلودگی صوتی و مزاحمت برای نوامیس و ... را نیز می توان ثبت کرد؟
  </p>
  <p class="bold-p px-2">
    خیر، در این سامانه فقط تخلف کشف حجاب را می توان ثبت کرد.
  </p>
  <p class="bold-p px-2">
    6.آیا می شودیک پلاک را که سرنشینان آن در کشف حجاب اصرار دارند در یک روز دوبار ثبت کرد؟
  </p>
  <p class="bold-p px-2">
    خیر هر کاربر برای یک پلاک در یک روز، فقط یک بار می تواند تخلف ثبت نماید.
  </p>
  <br/>
  <RouterLink to="/final-exam-rule" class="bbot mx-auto">
    صفحه بعد ◀
  </RouterLink>
</template>

<script>
// export default {
//   name: "FaqView"
// }
</script>

<style scoped>

</style>